import React, { Suspense, lazy } from 'react';
//import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import logo from '@/assets/images/logo.webp';
import PrivacyPolicy from './pages/privacy-policy';
import TawkToWidget from './components/TawkToWidget';
import StructuredData from "./components/StructuredData";
import { HelmetProvider } from "react-helmet-async";

//import TawkToWidget from "./TawkToWidget";

// Lazy-loaded pages
const Home = lazy(() => import('./pages/Home'));
const ContactUs = lazy(() => import('./pages/contact-us'));
const ResidentialProject = lazy(() => import('./pages/residential-project'));
const IndustrialProject = lazy(() => import('./pages/industrial-project'));
const CommercialProject = lazy(() => import('./pages/commercial-project'));
const ProjectDetailsPage = lazy(() => import('./pages/project-detail'));
const Blog = lazy(() => import('./pages/blog'));
const BlogDetails = lazy(() => import('./pages/blog-details'));
const AboutUs = lazy(() => import('./pages/about-us'));
const Media = lazy(() => import('./pages/Media'));
const Career = lazy(() => import('./pages/career'));
const Award = lazy(() => import('./pages/award'));
const PartnerUs = lazy(() => import('./pages/partner-us'));
const Certifications = lazy(() => import('./pages/certifications'));
const ThankYou = lazy(() => import('./pages/thank-you'));


function Loader() {
  return (
    <div className="flex items-center justify-center min-h-screen bg-black">
      <div className="relative flex justify-center items-center w-32 h-32 rounded-full bg-yellow-600 shadow-md">
        {/* Animated border */}
        <div className="absolute w-full h-full rounded-full border-4 border-white border-t-transparent animate-spin-slow"></div>

        {/* Logo inside */}
        <img src={logo} alt="KGK Logo" className="h-24 w-auto z-10" />
      </div>
    </div>
  );
}

function App() {
  return (
    <>
   
      <HelmetProvider>
          <StructuredData />
    <Router>
        <TawkToWidget /> {/*Tawk.to loads globally */}
      <Suspense fallback={<Loader />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/residential-projects" element={<ResidentialProject />} />
          {/* <Route path="/residential-projects" element={<ResidentialProject />} /> */}
           {/* <Route path="/residential-projects/:city" element={<ResidentialProject />} /> */}
          <Route path="/residential-projects/:city" element={<ResidentialProject />} />
          <Route path="/industrial-project" element={<IndustrialProject />} />
          <Route path="/commercial-project" element={<CommercialProject />} />
          <Route path="/project-details/:slug" element={<ProjectDetailsPage />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogDetails />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/media" element={<Media />} />
          <Route path="/career" element={<Career />} />
          <Route path="/award" element={<Award />} />
          <Route path="/partner" element={<PartnerUs />} />
          <Route path="/certifications" element={<Certifications />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/thank-you" element={<ThankYou />} />
        </Routes>
      </Suspense>
    </Router>
    </HelmetProvider>
    </>
    
  );
}

export default App;
